import React, { ReactNode, useState } from 'react';
import Arrow from '../../assets/icons/Arrow';
import { cn } from '../../utils';

type AccordionProps = {
  title: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
};

const Accordion: React.FC<AccordionProps> = ({
  title,
  children,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className='flex flex-col'>
      <button
        onClick={() => setIsOpen(!isOpen)}
        type='button'
        className={`
          text-md flex w-full items-center justify-between text-left font-medium uppercase
          text-green-blue-1 transition-colors
        `}
      >
        <span>{title}</span>

        <Arrow rotated={isOpen} />
      </button>

      <div>
        <div
          className={cn(
            'flex flex-col gap-2 transition-all duration-300',
            isOpen
              ? 'max-h-screen overflow-visible'
              : 'max-h-[0px] overflow-hidden',
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
